/// <amd-module name="Core/Medius.Core.Web/Scripts/AdminPages/AutoCoding/dimensionOverridenValue"/>
export enum DimensionOverridenValue {
    Configured = 0,
    ERP = 1,
    SaC = 2,
    SaD = 3
}
